import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { InfiniteQueryResult } from '@frontend/types';
import { ScheduleActionsProvider } from '../../../ScheduleActionsProvider';
import { ScheduleRequestPanel } from '../../ScheduleRequestModal/ScheduleRequestWrappers/ScheduleRequestPanel';
import { ScheduleRequestListContent } from '../ScheduleRequestListContent';
import { ScheduleRequestWidgetListItem } from './ScheduleRequestWidgetListItem';

interface ScheduleRequestWidgetListProps {
  height?: number | string;
  refetchScheduleRequestList: () => void;
  infiniteListQuery: InfiniteQueryResult<Record<'rows', ScheduleRequest[]>>;
}

export const ScheduleRequestWidgetList = ({
  height,
  infiniteListQuery,
  refetchScheduleRequestList,
}: ScheduleRequestWidgetListProps) => {
  return (
    <ScheduleActionsProvider>
      <ScheduleRequestListContent
        refetchScheduleRequestList={refetchScheduleRequestList}
        infiniteListQuery={infiniteListQuery}
        height={height}
        modalWrapper={ScheduleRequestPanel}
        scheduleRequestListItem={ScheduleRequestWidgetListItem}
      />
    </ScheduleActionsProvider>
  );
};
